import { Stack, Text } from "@mantine/core";

export const IngestRuleTemplateCard = (props: { subject: string; body: string }) => {
    return (
        <Stack gap={0}>
            <Text fw="bold">{props.subject}</Text>
            <Text size="xs" c="dimmed" lineClamp={3} maw="100%">
                {props.body}
            </Text>
        </Stack>
    );
};
